var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('video',{ref:"videoControl",staticClass:"video-player",style:({
			transform: ("translate(" + _vm.panX + "px, " + _vm.panY + "px) scale(" + _vm.zoomLevel + ")"),
			transformOrigin: 'center center'
		}),attrs:{"autoplay":"","muted":""},domProps:{"muted":true},on:{"loadeddata":_vm.OnLoadedData}}),_c('video',{ref:"videoControlDuration",staticClass:"video-player-hidden",attrs:{"autoplay":"","muted":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }